import { c as createFocusTrap } from './focus-trap.js';
import { pubsub } from '@services';

/**
 * Open the dialog.
 * @param {HTMLElement} dialog - The dialog to open.
 */
function openDialog(dialog) {
  if (dialog.open) return;
  dialog.showModal();

  // Create the focus trap if it doesn't exist
  if (!dialog.trap) {
    dialog.trap = createFocusTrap(dialog, {
      // Allow clicks outside the dialog to close the dialog
      allowOutsideClick: true,
    });
  }
  dialog.trap.activate();
}

/**
 * Close the dialog.
 * @param {HTMLElement} dialog - The dialog to close.
 */
function closeDialog(dialog) {
  if (!dialog.open) return;
  dialog.trap.deactivate();
  setTimeout(() => {
    dialog.close();
  }, 100);
}

/**
 * Listen for dialog:open events
 */
pubsub.subscribe('dialog:open', ({ dialogId }) => {
  const dialog = document.getElementById(dialogId);
  if (dialog) openDialog(dialog);
});

/**
 * Listen for dialog:close events
 */
pubsub.subscribe('dialog:close', ({ dialogId }) => {
  const dialog = document.getElementById(dialogId);
  if (dialog) closeDialog(dialog);
});

/**
 * Listen for key:escape events
 */
pubsub.subscribe('key:escape', () => {
  const dialog = document.querySelector('dialog[open]');
  if (dialog) closeDialog(dialog);
});

/**
 * Listen for clicks on data-dialog-controller
 */
document.addEventListener('click', (event) => {
  const target = event.target;

  // Handle dialog controllers
  if (target.closest('[data-dialog-controller]')) {
    const dialogId = target.closest('[data-dialog-controller]').getAttribute('aria-controls');
    const dialog = document.getElementById(dialogId);
    if (!dialog) {
      console.error(`Dialog with id '${dialogId}' not found`);
      return;
    }

    // Toggle behavior: open if closed, close if open
    dialog.open ? closeDialog(dialog) : openDialog(dialog);
  }

  // Handle click on dialog background to close
  if (target.nodeName === 'DIALOG') closeDialog(target);
});
